export default "__VITE_ASSET__HECfVpL3__"